<!--
  cmpltSal.vue ( 8 step, cmpltSal03 )
  - 완전판매
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section monitor_wrap">
          <div class="title_monitor">
            <p class="title">{{ state.untPdNm }}</p>
            <p class="num_qst">
              문항수 : <em class="point">{{ state.motrCnt }}</em> /
              {{ state.motrMndcList.length }}
            </p>
          </div>
          <p class="tit_tbl">계약기본사항</p>
          <div class="data_table type_row data">
            <table>
              <caption class="blind">
                계약기본사항
              </caption>
              <colgroup>
                <col style="width: 25%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">가계약번호</th>
                  <td>{{ state.prctrNo }}</td>
                </tr>
                <tr>
                  <th scope="row">계약자</th>
                  <td>{{ state.polhdNm }}</td>
                </tr>
                <tr>
                  <th scope="row">피보험자</th>
                  <td>{{ state.maInspeNm }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 모니터링 확인 -->
          <p class="tit_tbl">모니터링 확인</p>
          <div class="list_monitor">
            <template v-for="(list, idx) in state.motrMndcList" :key="idx">
              <div
                class="card show"
                v-if="idx <= state.motrCnt && list.showflag"
                :class="list.flag == '1' ? 'check_no' : ''"
                :ref="(el) => (motrMndcRefLs[idx] = el)"
              >
                <!-- 카드 숨김(default) / 노출 .show 클래스 추가 -->
                <div class="card_head">
                  <p class="qst_tit">{{ list.qstLctgNm }}</p>
                  <div class="qst_txt" v-html="idx + 1 + '. ' + list.con"></div>
                </div>
                <div class="card_body">
                  <div class="ans_group">
                    <template v-if="list.replyTp == '1'">
                      <span
                        class="radio_box"
                        v-for="(item, itemIdx) in list.qstTrmList"
                        :key="itemIdx"
                      >
                        <input
                          type="radio"
                          :name="'qst' + (idx + 1)"
                          :id="'qst' + (idx + 1) + '_' + (itemIdx + 1)"
                          @change="setMotrCnt(list, item, itemIdx)"
                        />
                        <label :for="'qst' + (idx + 1) + '_' + (itemIdx + 1)">{{
                          item.title
                        }}</label>
                      </span>
                    </template>
                  </div>
                  <p class="comment" v-html="list.cnsGuidCon"></p>
                  <div
                    class="ans_reason"
                    v-if="
                      list.showflag &&
                      list.qstTpCd != '1' &&
                      list.replyTp == '2'
                    "
                  >
                    <label for="ans_reasonInput">사유</label
                    ><input
                      type="text"
                      id="ans_reasonInput"
                      class="inputBox"
                      title="사유"
                      placeholder="사유를 입력해 주세요."
                      @input="list.rcrtPthVltCon = $event.target.value"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- //list_monitor -->
          <div class="btn_area">
            <button
              type="button"
              class="btn_main"
              :disabled="state.inpCompYn ? false : true"
              @click="save"
            >
              <span>입력완료</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <iframe
      id="downloadFrame"
      ref="downloadFrame"
      style="width: 0px; height: 0px"
      src=""
    ></iframe>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUpdate,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
export default {
  name: "cmpltSal",
  components: {
    Header,
    Footer,
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const motrMndcRefLs = ref([]);

    onBeforeUpdate(() => {
      motrMndcRefLs.value = [];
    });

    onMounted(async () => {
      await load();
      util.saveLog("009", "완전판매계약기본사항"); // 009 : 화면진입
      if (
        sessionUserInfo.rpsPdCd == "61139" ||
        sessionUserInfo.rpsPdCd == "61238" ||
        sessionUserInfo.rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      state.prctrNo = sessionUserInfo.prctrNo;
      state.untPdNm = sessionUserInfo.untPdNm;
      variables.orgCd = sessionUserInfo.orgCd;
      variables.multiCon = sessionUserInfo.multiCon;

      if (store.state.elcSgnInf.cmpltSalCompFlag) {
        router.push({ name: "cmpltSalComp" });
        return;
      }

      loadMotr();
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
      untPdNm: "",
      motrCnt: "",
      motrMndcList: "",
      prctrNo: "",
      polhdNm: "",
      maInspeNm: "",
      inpCompYn: false,
    });

    const variables = {
      rcrtPthVltConTr: 0,
      cmpltSalMotrDivCd: "01",
      orgCd: "",
      bizFunCd: "002",
      multiCon: "",
      jobNm: "",
      ntdtJobCon: "",
    };

    const loadMotr = () => {
      let param = {
        prctrNo: state.prctrNo,
        cmpltSalMotrDivCd: variables.cmpltSalMotrDivCd,
        orgCd: variables.orgCd,
        bizFunCd: variables.bizFunCd,
      };

      axios.json("/cmpltSal/retrieveMotrMndcInf.do", param).then((result) => {
        console.log(result);
        if (result) {
          try {
            if (result.data.MotrMndcList.length > 0) {
              state.motrCnt = 0;
              state.motrMndcList = result.data.MotrMndcList;
              state.polhdNm = result.data.polhdNm;
              state.maInspeNm = result.data.maInspeNm;

              variables.jobNm = result.data.jobNm;
              variables.ntdtJobCon = result.data.ntdtJobCon;

              let cnt = 0;

              //답변항목 가변처리
              _.each(state.motrMndcList, function (obj) {
                let qstTrmList = [];
                let rspnConLst = obj.rspnCon.split("|");

                if (rspnConLst == "{0}") {
                  obj.replyTp = "2";
                } else {
                  obj.replyTp = "1";
                }

                let rspnCdLst = obj.rspnCd.split("|");
                for (let i = 0; i < rspnConLst.length; i++) {
                  let qstTrm = {};
                  qstTrm.title = rspnConLst[i];
                  qstTrm.value = rspnCdLst[i];
                  qstTrmList.push(qstTrm);
                }
                obj.index = cnt;
                obj.qstTrmList = qstTrmList;
                cnt++;

                if (obj.qstTpCd == "1") {
                  obj.showflag = true;
                } else {
                  obj.showflag = false;
                }
              });
            } else {
              dialog.alert("완전판매 대상건이 아닙니다.").then(function () {
                return false;
              });
            }
          } catch (e) {
            console.log(e);
            dialog.alert("완전판매 대상건이 아닙니다.").then(function () {
              return false;
            });
          }
        }
      });
    };

    const setMotrCnt = async (obj, replyTrm, index) => {
      if (
        replyTrm.value != "A" &&
        obj.motrTrgCd != "null" &&
        obj.motrTrgCd != null &&
        obj.motrTrgCd != undefined
      ) {
        // 39번 질문, 아니오인경우 '  답변' 내용저장.
        if (obj.sno == "39" || obj.sno == "72") {
        } else if (obj.sno == "116") {
          //설문번호 116번 존재시  답변이 지인/소개인 경우 다음 설문 비활성화
          variables.rcrtPthVltCon = "";
        } else if (obj.sno == "117") {
          variables.rcrtPthVltCon = "";
        } else {
          //불완전판매목록 color 변경 및 popup 처리
          obj.survey_error = "survey_error";
          variables.rcrtPthVltCon = "";
          dialog.alert(
            "불완전판매 항목이 발생하였습니다.<br> 해당 내용에 대해 보험계약 담당자에게 다시 한번 확인하시기 바랍니다."
          );
        }
      } else {
        obj.survey_error = "";
        if (obj.sno == "39") {
          variables.rcrtPthVltConTr = 0;
        }
      }

      obj.selectFlag = true;

      //선택한 설문항목 값
      let selectVal = replyTrm.value;

      //다음설문항목번호
      let addQstIdfNo = obj.addQstIdfNo;
      //다음설문항목
      let addQstReplyVal = obj.addQstReplyVal;
      _.each(state.motrMndcList, function (obj) {
        if (
          obj.qstTpCd == "2" &&
          obj.qstIdfNo == addQstIdfNo &&
          addQstReplyVal == selectVal
        ) {
          obj.showflag = true;
          obj.selectFlag = true;
        } else if (
          obj.qstTpCd == "2" &&
          obj.qstIdfNo == addQstIdfNo &&
          addQstReplyVal != selectVal
        ) {
          obj.showflag = false;
          obj.selectFlag = true;
        }
      });

      let motrCnt = 0;
      _.each(state.motrMndcList, function (item, key) {
        if (item.selectFlag) {
          motrCnt++;
        }
      });

      state.motrCnt = motrCnt;
      obj.flag = index;
      obj.value = selectVal;

      if (state.motrMndcList.length != motrCnt) {
        await nextTick();
        window.scrollBy({
          top: motrMndcRefLs.value[motrCnt].getBoundingClientRect().top - 30,
          behavior: "smooth",
        });
      } else {
        state.inpCompYn = true;
      }
    };

    const save = () => {
      let skipFlag = false;
      _.each(state.motrMndcList, function (obj) {
        if (obj.sno == "116" && (obj.value == "B" || obj.value == "C")) {
          skipFlag = true;
        }

        if (skipFlag && obj.sno == "117") {
          obj.value = "X";
        }
      });

      //문항갯수만큼 선택하였는지 체크
      if (state.motrCnt == state.motrMndcList.length || skipFlag) {
        let checkVal = _.findLastIndex(state.motrMndcList, {
          survey_error: "survey_error",
        });

        if (checkVal != "-1") {
          dialog
            .confirm(
              "고객님께서 답변하신 내용 중 불완전판매 항목이 있습니다. <br><br> 설문내용을 다시 확인하시겠습니까?",
              "메리츠화재"
            )
            .then(function (result) {
              console.log(result);
              if (result == "2") {
                dialog
                  .confirm(
                    "설문항목 중 (아니오/모른다)는 답변이 있어 [불완전판매]처리 됩니다. <br><br> 정말 저장하시겠습니까?",
                    "메리츠화재"
                  )
                  .then(function (result) {
                    if (result == "1") {
                      saveMotr();
                    }
                  });
              }
            });
        } else {
          saveMotr();
        }
      } else {
        dialog.alert("모든 문항에 답변하시기 바랍니다.");
        return false;
      }
    };

    const saveMotr = () => {
      //주관식 항목 필터
      let rcrtPthVltList = _.filter(state.motrMndcList, function (info) {
        return info.sno == "901" || info.sno == "902";
      });

      //주관식 항목 벨리데이션 체크
      for (var i = 0; i < rcrtPthVltList.length; i++) {
        if (rcrtPthVltList[i].sno == "901") {
          if (
            rcrtPthVltList[i].showflag &&
            (rcrtPthVltList[i].rcrtPthVltCon == undefined ||
              rcrtPthVltList[i].rcrtPthVltCon == "")
          ) {
            dialog.alert(
              "고객님께서는 개인신용정보를 보험모집인에게 합법적으로 제공하지 않았다고 답변하셨습니다.<br> 어떠한 경로로 보험계약을 체결하셨는지 하단 입력창에 기재해 주시면 감사하겠습니다."
            );
            return;
          }
        } else {
          if (
            rcrtPthVltList[i].showflag &&
            (rcrtPthVltList[i].rcrtPthVltCon == undefined ||
              rcrtPthVltList[i].rcrtPthVltCon == "")
          ) {
            dialog.alert(
              "고객님께서는 질병, 상해사고에 따른 과거병력 고지하지 않았다고 답변하셨습니다. </br> 어떠한 내용을 고지하지 않았는지 하단 입력창에 기재해 주시면 감사하겠습니다."
            );
            return;
          }
        }
      }

      //보험상품, 청약일
      //취소인경우 공인인증 후 결과화면으로 이동.
      let motrList = new Array();
      _.each(state.motrMndcList, function (item, key) {
        if (item.showflag) {
          let qstReplyCon = "";
          if (item.rcrtPthVltCon != undefined && item.rcrtPthVltCon != "") {
            qstReplyCon = item.rcrtPthVltCon;
          }

          let data = "";

          if (item.rspnCd == "I") {
            data = item.rspnCd;
          } else {
            data = item.value;
          }

          var obj = {
            cmpltSalTrmCd: item.sno,
            rspnCd: data,
            qstIdfNo: item.qstIdfNo,
            motrTrgCd: item.motrTrgCd,
            qstReplyCon: qstReplyCon,
          };
          motrList.push(obj);
        } else {
          var obj = {
            cmpltSalTrmCd: item.sno,
            rspnCd: "X",
            qstIdfNo: item.qstIdfNo,
            motrTrgCd: item.motrTrgCd,
            qstReplyCon: "",
          };
          motrList.push(obj);
        }
      });

      let param = {
        prctrNo: state.prctrNo,
        motrList: motrList,
        cmpltSalMotrDivCd: variables.cmpltSalMotrDivCd,
        rcrtPthVltCon: "",
        bizFunCd: variables.bizFunCd,
        jobNm: variables.jobNm,
        ntdtJobCon: variables.ntdtJobCon,
      };

      //상품명, 청약일..
      axios
        .json("/cmpltSal/saveCmpltSalMotr.do", param)
        .then(function (result) {
          if (result) {
            store.commit("elcSgnInf/changeCmpltSalCompFlag", true);
            //   if (variables.multiCon == 'Y') {
            //     dialog
            //       .alert(
            //         '완전판매 모니터링이 완료 되었습니다. 계약목록 화면으로 이동합니다.'
            //       )
            //       .then(function() {
            //         router.push({ name: 'mlpxCtrBasMttCnf' })
            //       })
            //   } else {
            router.push({ name: "cmpltSalComp" });
            //   }
          }
        });
    };

    return {
      state,
      load,
      setMotrCnt,
      save,
      motrMndcRefLs,
      sessionUserInfo,
    };
  },
  methods: {},
};
</script>

<style>
.comment font[color="red"] {
  color: red;
}
</style>
